import { DialogModule } from '../validation/schema/v1/story';
import omitBy from "lodash.omitby";

/**
 * This function should be used temporarily. The client is setting values to `null` 
 * when it should have been `undefined`. This function is a helper for that.
 * Once the game is fixed to not save more nulls, we should deprecate the function
 */

const omitByDeep = <T>(obj: Record<string, any>, fn: ((v: any) => boolean)): T => {
  // _.omitBy(object, (v) => v === null);
  return Object.keys(obj).reduce((res: Record<string, any>, cur: string) => {

    let value = obj[cur];

    const isObj = typeof value === 'object';
    const isArray = Array.isArray(value);
    const isArrayOfObjs = isArray && typeof value[0] === 'object';

    if (isArrayOfObjs) {
      value = value.map((o: any) => omitByDeep(o, fn));
    }

    return {
      ...res,
      [cur]: isObj && !isArray ? omitByDeep(omitBy(value, fn), fn) : value,
    }
  }, {} as Record<string, any>) as T;
}
 

export const ensureNoNullables = (story: DialogModule): DialogModule => {
  return omitByDeep(story, (v) => v === null);
};
